var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6837 16.3913L9.91598 18.1591L3.43751 11.6806L3.43415 11.684L1.66638 9.9162L1.66975 9.91284L1.6664 9.90949L3.43417 8.14173L3.43751 8.14507L9.91596 1.66663L11.6837 3.43439L5.20528 9.91284L11.6837 16.3913Z",
    fill: "#9599A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3504 16.3913L16.5826 18.1591L10.1042 11.6806L10.1008 11.684L8.33305 9.9162L8.33641 9.91284L8.33307 9.90949L10.1008 8.14173L10.1042 8.14507L16.5826 1.66663L18.3504 3.43439L11.8719 9.91284L18.3504 16.3913Z",
    fill: "#9599A1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftArrow);
export default __webpack_public_path__ + "static/media/double_left_arrow.60b983db4f4a3faa545d33415b06738c.svg";
export { ForwardRef as ReactComponent };